import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=55685a48&scoped=true"
import script from "./DetailHeader.vue?vue&type=script&lang=js"
export * from "./DetailHeader.vue?vue&type=script&lang=js"
import style0 from "./DetailHeader.vue?vue&type=style&index=0&id=55685a48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55685a48",
  null
  
)

export default component.exports